const translateDataSourceSelection = {
  select: 'Pilih sumber data:',
  select2: 'Pilih dua (2) sumber data:',
};

export default translateDataSourceSelection;
